import React from "react";
import { currencyValue } from "utils/common";

export const displayDesktopRowItem = (row, col) => {
  if (row && col && col.dataKey && row[col.dataKey]) {
    if (
      col.name &&
      (col.name === "Bill Rates($)" ||
        col.name === "Installer Pay Rate" ||
        col.name === "New Bill Rates($)" ||
        col.name === "New Installer Pay Rate" ||
        col.name === "Old Price")
    ) {
      return currencyValue(row[col.dataKey]);
    } else {
      return row[col.dataKey];
    }
  } else {
    return "";
  }
};
